import {
  Home, FolderKanban, Users, Clock, Wrench, FileText, BookOpen,
  FileStack, TrendingUp, Package, ShoppingBag, Headphones, CalendarDays,
  Wallet, Banknote, ShieldCheck, Settings, Gauge, Upload, MessageSquare,
  Building2, UserSquare2, CalendarRange,
} from 'lucide-react';

export const PRIORITY = [
  { path: '/dashboard', label: 'Dashboard', icon: Home },
  { path: '/dashboard/projects', label: 'Projekt', icon: FolderKanban },
];

export const SECTIONS = [
  { title: 'Planering', items: [
    { path: '/dashboard/calendar', label: 'Kalender', icon: CalendarDays, badgeKey: 'calendar' },
    { path: '/dashboard/schedule', label: 'Schema', icon: CalendarRange },
    { path: '/dashboard/eta', label: 'ÄTA', icon: FileText, badgeKey: 'eta' },
    { path: '/dashboard/daybook', label: 'Dagbok', icon: BookOpen },
  ] },
  { title: 'Resurser', items: [
    { path: '/dashboard/employees', label: 'Personal', icon: Users },
    { path: '/dashboard/time-reports', label: 'Tidrapporter', icon: Clock, badgeKey: 'time_reports' },
    { path: '/dashboard/inventory', label: 'Lager', icon: Package },
    { path: '/dashboard/machines', label: 'Maskiner', icon: Wrench },
    { path: '/dashboard/machine-hours', label: 'Maskintimmar', icon: Gauge },
  ] },
  { title: 'Ekonomi', items: [
    { path: '/dashboard/invoices', label: 'Fakturor', icon: FileStack, badgeKey: 'invoices' },
    { path: '/dashboard/customers', label: 'Kunder', icon: UserSquare2 },
    { path: '/dashboard/billing-profiles', label: 'Fakturabolag', icon: Building2 },
    { path: '/dashboard/payroll', label: 'Löner (snabb)', icon: Wallet },
    { path: '/dashboard/payroll-runs', label: 'Löneutbetalning', icon: Banknote },
    { path: '/dashboard/accounting', label: 'Bokföring', icon: BookOpen },
    { path: '/dashboard/import', label: 'Dataimport', icon: Upload },
  ] },
  { title: 'Affär', items: [
    { path: '/dashboard/suppliers', label: 'Leverantörer', icon: Package },
    { path: '/dashboard/tenders', label: 'Upphandlingar', icon: TrendingUp },
    { path: '/dashboard/compare-offer', label: 'Jämför Offert', icon: ShoppingBag },
  ] },
  { title: 'System', items: [
    { path: '/dashboard/chat', label: 'Intern Chatt', icon: MessageSquare },
    { path: '/dashboard/support-chat', label: 'Support', icon: Headphones, badgeKey: 'support_chat' },
    { path: '/dashboard/security', label: 'Säkerhet', icon: ShieldCheck },
    { path: '/dashboard/settings', label: 'Inställningar', icon: Settings },
  ] },
];

export const ALL_ITEMS = [...PRIORITY, ...SECTIONS.flatMap((s) => s.items)];

export const navTestId = (label) =>
  `nav-${label.toLowerCase().replace(/\s+/g, '-').replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/å/g, 'a')}`;

export const matchItem = (pathname) =>
  ALL_ITEMS.find((it) => it.path === pathname || (it.path !== '/dashboard' && pathname.startsWith(it.path + '/')));
